import React from 'react';
import { useTranslation } from 'react-i18next';

const useNoRowsTemplate = (): string => {
  const { t } = useTranslation();
  const message: string = t('grid.noRows');
  const noRowsTemplate: string = '<span class="ag-overlay-loading-center">' + message + '</span>';

  return noRowsTemplate;
};

export default useNoRowsTemplate;
